
import { IEnvConfigUtils } from "Interfaces/Utils/IEnvConfigUtils";
import * as React from "react";
import { connect } from "react-redux";
import ServiceProvider from "ServiceProvider/ServiceProvider";
import Types from "ServiceProvider/Types";
import { IAuthenticationState } from "Store/Authentication/AuthenticationActionTypes";
import { IApplicationState } from "Store/Store";

const envConfigUtils = ServiceProvider.get<IEnvConfigUtils>(Types.IEnvConfigUtils);

interface IProps {
    authenticationState: IAuthenticationState;
}

const mapStateToProps = (state: IApplicationState) => ({
    authenticationState: state.authenticationState
});

export class LogoutComponent extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
        this.logout();
    }

    private logout() {
        // Remove SessionStorage
        sessionStorage.clear();

        // Redirect to cms logout
        const cmsUrl = envConfigUtils.getEnvVariables().cmsUrl;
        const url = cmsUrl + "/logout";
        window.location.href = url;
    }

    public render() {
        return null;
    }
}

export default connect(mapStateToProps)(LogoutComponent);


// WEBPACK FOOTER //
// ./src/Components/Authentication/LogoutComponent.ts